export const recentTradeRowCount = 50
